import { Container, Box, Typography, Button } from "@mui/material";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import locales from "../locales.json";  // Importation des traductions
import { useLang } from "../context/LangContext";  // Hook pour récupérer la langue

const ResetPasswordEmailSent = () => {
  const { lang } = useLang();
  const { reset_password_email_sent } = locales; // Récupération des traductions

  return (
    <Container
      maxWidth="sm"
      sx={{
        minHeight: { xs: '100vh', md: 'calc(100vh - 64px)' },
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        px: { xs: 1, sm: 2, md: 0 },
        boxSizing: 'border-box',
        width: '100%',
      }}
    >
      <Box
        sx={{
          backgroundColor: "#f9f9f9",
          padding: { xs: '20px', sm: '32px' },
          borderRadius: "16px",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
          textAlign: "center",
          width: "100%",
          maxWidth: "400px",
          mx: "auto",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <EmailOutlinedIcon sx={{ fontSize: 60, color: "primary.main", mb: 2 }} />
        <Typography variant="h4" gutterBottom sx={{ fontSize: { xs: '1.5rem', md: '2rem' } }}>
          {reset_password_email_sent.title[lang]}
        </Typography>
        <Typography variant="body1" color="textSecondary" sx={{ fontSize: { xs: '1rem', md: '1.1rem' } }}>
          {reset_password_email_sent.message[lang]}
        </Typography>
        <Typography variant="body2" color="textSecondary" sx={{ mt: 1, fontSize: { xs: '0.95rem', md: '1rem' } }}>
          {reset_password_email_sent.spam_warning[lang]}
        </Typography>

        <Button
          variant="contained"
          color="primary"
          fullWidth
          sx={{ mt: 3, padding: { xs: '10px 0', md: '12px 0' }, borderRadius: "24px", fontSize: { xs: '1rem', md: '1.1rem' } }}
          onClick={() => window.location.href = "/signin"}
        >
          {reset_password_email_sent.back_to_signin[lang]}
        </Button>
      </Box>
    </Container>
  );
};

export default ResetPasswordEmailSent;
